import { Popover, Checkbox } from 'antd';
import { useState } from 'react';
import './index.scss';

interface FilterPillPopupProps {
  filterKey: string;
  filterLabel: string;
  selectedValues: string[];
  options: { label: string; value: string }[];
  onDeselect: (value: string) => void;
  onClearAll: () => void;
  children: React.ReactNode;
}

export default function FilterPillPopup({
  filterKey,
  filterLabel,
  selectedValues,
  options,
  onDeselect,
  onClearAll,
  children
}: FilterPillPopupProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleCheckboxChange = (value: string, checked: boolean) => {
    if (!checked) {
      onDeselect(value);
    }
  };

  const content = (
    <div className="filter-pill-popup">
      <div className="filter-pill-popup-header">
        <span className="popup-title">{filterLabel}</span>
        <button className="clear-all-button" onClick={() => {
          onClearAll();
          setIsOpen(false);
        }}>
          Clear All
        </button>
      </div>
      <div className="filter-pill-popup-content">
        {options
          .filter(option => selectedValues.includes(option.value))
          .map((option) => (
            <div key={option.value} className="filter-pill-popup-item">
              <Checkbox
                checked={true}
                onChange={(e) => handleCheckboxChange(option.value, e.target.checked)}
              >
                {option.label}
              </Checkbox>
            </div>
          ))}
      </div>
    </div>
  );

  return (
    <Popover
      content={content}
      trigger="click"
      open={isOpen}
      onOpenChange={setIsOpen}
      placement="bottomLeft"
      overlayClassName="filter-pill-popover"
      getPopupContainer={(triggerNode) => triggerNode.parentElement || document.body}
      destroyTooltipOnHide
    >
      {children}
    </Popover>
  );
}

